module.exports = __webpack_public_path__ + "img/main-1_m.5d4595db.jpg";